import { httpCadastro } from "../plugins/http";

let endpoint = "/v1/cadastro";

const sanitizeResponse = (data) => {
  if (typeof data === 'object' && data !== null) {
    for (const key in data) {
      if (typeof data[key] === 'string') {
        data[key] = data[key].replace(/\?/g, ' '); 
      }
    }
  }
  return data;
};

export default {
  getEmissaoViagem: (tipoFiltro, valor, status, idUsuario) => {
    let url =
      endpoint +
      "/emissao-viagem" +
      "/busca?tipoFiltro=" +
      tipoFiltro +
      "&valor=" +
      valor +
      "&idUsuario=" +
      idUsuario +
      "&status=" +
      status;

    return httpCadastro
      .get(url, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((response) => {
        response.data = sanitizeResponse(response.data);
        return response;
      });
  },

  insert: (EmissoViagemData) => {
    return httpCadastro.post(endpoint + "/emissao-viagem", EmissoViagemData, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  update: (id, EmissoViagemData) => {
    return httpCadastro.put(
      `${endpoint + "/emissao-viagem"}/${id}`,
      EmissoViagemData,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  delete: (id) => {
    return httpCadastro.delete(`${endpoint}/emissao-viagem/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getCpfCnpj: (cpfCnpj) => {
    let url = endpoint + "/pessoa/cpf-cnpj?cpfCnpj=" + cpfCnpj;

    return httpCadastro
      .get(url, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((response) => {
        response.data = sanitizeResponse(response.data);
        return response;
      });
  },

  getNotaFiscais: (idEmissaoViagem) => {
    let url =
      endpoint +
      "/emissao-viagem-nota-fiscal" +
      "/busca?idEmissaoViagem=" +
      idEmissaoViagem;

    return httpCadastro
      .get(url, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((response) => {
        response.data = sanitizeResponse(response.data);
        return response;
      });
  },

  getNotaFiscaisCte: (idEmissaoViagem, idRemetente, idDestinatario) => {
    let url =
      endpoint +
      "/emissao-viagem-nota-fiscal" +
      "/busca-cte?idRemetente=" +
      idRemetente +
      "&idDestinatario=" +
      idDestinatario +
      "&idEmissaoViagem=" +
      idEmissaoViagem;

    return httpCadastro
      .get(url, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((response) => {
        response.data = sanitizeResponse(response.data);
        return response;
      });
  },

  getCtes: (idEmissaoViagem) => {
    let url =
      endpoint +
      "/emissao-viagem-cte" +
      "/busca?idEmissaoViagem=" +
      idEmissaoViagem;

    return httpCadastro
      .get(url, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((response) => {
        response.data = sanitizeResponse(response.data);
        return response;
      });
  },

  validarCte: (id) => {
    return httpCadastro.post(`${endpoint}/emissao-viagem-cte/validar-cte/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  validarMdfe: (id) => {
    console.log("PASSOU AQUI 3");
    return httpCadastro.post(`${endpoint}/emissao-viagem-mdfe/validar-mdfe/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },
  
  getMdfes: (idEmissaoViagem) => {
    let url =
      endpoint +
      "/emissao-viagem-mdfe" +
      "/busca?idEmissaoViagem=" +
      idEmissaoViagem;
    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },  

  getImportarNotaFiscal: (xml) => {
    return httpCadastro
      .post(endpoint + "/emissao-viagem-nota-fiscal/importar-nfe", xml, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Content-Type": "application/xml",
        },
      })
      .then((response) => {
        response.data = sanitizeResponse(response.data);
        return response;
      });
  },

  insertNotaFiscal: (EmissoViagemNotaFiscalData) => {
    return httpCadastro.post(
      endpoint + "/emissao-viagem-nota-fiscal",
      EmissoViagemNotaFiscalData,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  updateNotaFiscal: (id, EmissoViagemNotaFiscalData) => {
    return httpCadastro.put(
      `${endpoint + "/emissao-viagem-nota-fiscal"}/${id}`,
      EmissoViagemNotaFiscalData,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  updateCte: (id, EmissoViagemCteData) => {
    return httpCadastro.put(
      `${endpoint + "/emissao-viagem-cte"}/${id}`,
      EmissoViagemCteData,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  updateAllCtes: (idEmissaoViagem, EmissoViagemCteData) => {
    console.log("PASSOU AQUI EmissoViagemCteData: ", EmissoViagemCteData);

    return httpCadastro.put(
      `${endpoint + "/emissao-viagem-cte/atualizar-ctes"}/${idEmissaoViagem}`,
      EmissoViagemCteData,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  updateMdfe: (id, EmissoViagemMdfeData) => {    
    return httpCadastro.put(
      `${endpoint + "/emissao-viagem-mdfe"}/${id}`,
      EmissoViagemMdfeData,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  deleteNotaFiscal: (id) => {
    return httpCadastro.delete(`${endpoint}/emissao-viagem-nota-fiscal/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  prepareCte: (idEmissaoViagem) => {
    return httpCadastro.post(`${endpoint}/emissao-viagem-cte/prepare-cte/${idEmissaoViagem}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  prepareMdfe: (idEmissaoViagem) => {  
    return httpCadastro.post(`${endpoint}/emissao-viagem-mdfe/prepare-mdfe/${idEmissaoViagem}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getMotoristas: (idParticipante) => {
    let url =
      endpoint +
      "/motorista" +
      "/busca?idParticipante=" +
      idParticipante;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getVeiculos: (idParticipante) => {
    let url =
      endpoint +
      "/veiculo" +
      "/busca?idParticipante=" +
      idParticipante;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  /**
   * Busca dados COMPLETOS do veiculo (chassi, renavam, marca, modelo,
   * anoFabricacao, anoModelo, qtdEixos, tipoRodado, tipoRodagem, rntrc,
   * ibgeCidade, comtracao, etc). Necessario pra montar o payload CIOT -
   * o /veiculo/busca so retorna id + string formatada "PLACA - TIPO".
   */
  getVeiculoById: (id) => {
    return httpCadastro.get(`${endpoint}/veiculo/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getVeiculosTipo: (idParticipante, tipoVeiculo) => {
    let url =
      endpoint +
      "/veiculo" +
      "/busca-tipo-veiculo?idParticipante=" +
      idParticipante +
      "&tipoVeiculo=" +
      tipoVeiculo;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },
  
  getMunDesc: (idMdfeAvulso) => {
    let url =
      endpoint +
      "/emissao-viagem-mdfe-mun-desc" +
      "/busca?idMdfeAvulso=" +
      idMdfeAvulso;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  updateMunDesc: (id, cep) => {    
    return httpCadastro.put(
      `${endpoint + "/emissao-viagem-mdfe-mun-desc"}/${id}?cep=${cep}`,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  getPercurso: (idMdfeAvulso) => {
    let url =
      endpoint +
      "/emissao-viagem-mdfe-percurso" +
      "/busca?idMdfeAvulso=" +
      idMdfeAvulso;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  deletePercurso: (id) => {
    return httpCadastro.delete(`${endpoint}/emissao-viagem-mdfe-percurso/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },  

  insertPercurso: (EmissoViagemMdfePercurso) => {
    return httpCadastro.post(endpoint + "/emissao-viagem-mdfe-percurso", EmissoViagemMdfePercurso, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getReboque: (idMdfeAvulso) => {
    let url =
      endpoint +
      "/emissao-viagem-mdfe-reboque" +
      "/busca?idMdfeAvulso=" +
      idMdfeAvulso;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  deleteReboque: (id) => {
    return httpCadastro.delete(`${endpoint}/emissao-viagem-mdfe-reboque/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },  

  insertReboque: (EmissoViagemMdfeReboque) => {
    return httpCadastro.post(endpoint + "/emissao-viagem-mdfe-reboque", EmissoViagemMdfeReboque, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  alterarStatusCte: (id, status) => {
    return httpCadastro.put(
      `${endpoint + "/emissao-viagem-cte/status-cte"}/${id}/${status}`,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  alterarStatusMdfe: (id, status) => {
    return httpCadastro.put(
      `${endpoint + "/emissao-viagem-mdfe/status-mdfe"}/${id}/${status}`,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },


  getNotasFiscais: (chave = '', pagina = 1, tamanhoPagina = 20) => {
  const url =
      endpoint +
      "/emissao-viagem-nota-fiscal/notas-fiscais" +
      `?chave=${encodeURIComponent(chave)}` +
      `&pagina=${pagina}` +
      `&tamanhoPagina=${tamanhoPagina}`;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getNotaFiscalPorChave: (chave) => {
    const url = endpoint + "/emissao-viagem-nota-fiscal/busca-exata?chave=" + encodeURIComponent(chave);
    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },


  deletarNotaFiscal: (idNota) => {
  return httpCadastro.delete(`/v1/cadastro/emissao-viagem-nota-fiscal/${idNota}`, {
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
  });
  },

  //
  // ─── Rotina CIOT na Viagem (Fase B backend + Fase C/D front) ───
  //
  // Endpoints novos em /emissao-viagem/{id}/ciot* e /reboques.
  // Backend (wi-cadastro-api) reencaminha o Bearer do usuario pra
  // wi-ciot-api quando o envio eh automatico - o front so precisa
  // do mesmo Authorization padrao que ja usa hoje.
  //

  /**
   * Status de integracao CIOT do participante da viagem.
   * Retorno: { integrado: bool, codigoParticipante: str, provedor: str }
   * Usado pelo front pra decidir se mostra opcao Automatico.
   */
  getStatusIntegracaoCiot: (idViagem) => {
    return httpCadastro.get(
      `${endpoint}/emissao-viagem/${idViagem}/ciot/status-integracao`,
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    );
  },

  /** CIOT atual da viagem (ou 404 se ainda nao ha). */
  getCiotViagem: (idViagem) => {
    return httpCadastro.get(
      `${endpoint}/emissao-viagem/${idViagem}/ciot`,
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    );
  },

  /** Salva CIOT manual (12 chars) - upsert, sobrescreve tentativa anterior. */
  salvarCiotManual: (idViagem, numero) => {
    return httpCadastro.post(
      `${endpoint}/emissao-viagem/${idViagem}/ciot/manual`,
      { numero: (numero || '').trim() },
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    );
  },

  /**
   * Envia o CIOT automatico. Backend chama wi-ciot-api reencaminhando o
   * Bearer - qualquer erro retorna sucesso=false + descricaoMensagem.
   * Retorno: { sucesso, numero, senha, descricaoMensagem, idOperacaoCiotLog }
   */
  enviarCiot: (idViagem, payload) => {
    return httpCadastro.post(
      `${endpoint}/emissao-viagem/${idViagem}/ciot/enviar`,
      payload,
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    );
  },

  /** Lista reboques da viagem (cada item traz placa + qtdEixos). */
  getReboquesViagem: (idViagem) => {
    return httpCadastro.get(
      `${endpoint}/emissao-viagem/${idViagem}/reboques`,
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    );
  },

  /**
   * Substitui a lista completa de reboques da viagem.
   * idsVeiculo = array de Long. Vazio limpa.
   */
  updateReboquesViagem: (idViagem, idsVeiculo) => {
    return httpCadastro.put(
      `${endpoint}/emissao-viagem/${idViagem}/reboques`,
      { idsVeiculo: idsVeiculo || [] },
      { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
    );
  },

};
